import { Component } from '@angular/core';

@Component({
  selector: 'app-before-selfie',
  templateUrl: './before-selfie.component.html',
  styleUrls: ['./before-selfie.component.scss'],
})
export class BeforeSelfieComponent {}
